import { useCallback, useRef } from 'react';

import { drawLine, findSnapPoints, getOtherElementsBoundingBoxes, removeLine } from './snapping';

export const useSnap = (containerRef: any): any[] => {
    const containerBoundingBox = useRef<any>(containerRef.current && containerRef.current.getBoundingClientRect());

    const otherElements = useRef<any>(null);
    const lineRef = useRef<any>(null);
    const snapPoint = useRef<any>(null);

    const onDragStart = useCallback(
        (elementId: any, parentId: any) => {
            containerBoundingBox.current = containerRef.current.getBoundingClientRect();
            otherElements.current = getOtherElementsBoundingBoxes(containerBoundingBox.current, elementId, parentId);
        },
        [containerRef],
    );

    const onDragEnd = useCallback(() => {
        otherElements.current = null;
        removeLine(lineRef.current);
    }, []);

    const onDrag = useCallback(
        (elementId: any, parentId: any, _fromRight: boolean, boundingBox: any, left: number, width: number) => {
            if (!otherElements.current) {
                onDragStart(elementId, parentId);
            }

            // use element default if not provided
            const newWidth = width || boundingBox.width;

            const [lowestPoint, topPoint]: any = findSnapPoints(
                { x: left, width, y: boundingBox.y },
                otherElements.current,
                _fromRight,
            );

            if (lowestPoint && topPoint) {
                const fromRight = _fromRight || lowestPoint.fromRight || topPoint.fromRight;

                // add width if fromRight
                const lineLeft = left + (!!fromRight as any) * newWidth;
                snapPoint.current = [topPoint, lowestPoint].find((e: any) => e.elementId);
                drawLine(fromRight, lineRef.current, lineLeft, [lowestPoint, topPoint], containerBoundingBox.current.y);
            } else {
                removeLine(lineRef.current);
                snapPoint.current = null;
            }
        },
        [onDragStart],
    );

    const getSnapPoint = useCallback(() => snapPoint.current || {}, []);

    return [lineRef, onDrag, onDragEnd, getSnapPoint];
};
